class DCParameter {
    constructor() {
        this.branch = ''
        this.pvd_7 = ''
        this.pvd_15 = ''
        this.pvd_30 = ''
        this.pvd_60 = ''
        this.pvd_90 = ''
        this.mdv_7 = ''
        this.mdv_15 = ''
        this.mdv_30 = ''
        this.mdv_90 = ''
        this.stock_excess = ''
        this.coverage_period = ''
        this.stock_period = ''
        this.coverage_safety = ''
        this.stock_safety = ''
        this.stock_total = ''
        this.price = ''
        this.cost = ''
        this.coverage_max = ''
        this.actions = []
    }

    static get fieldNames() {
        return {
            branch: 'CD',
            pvd_7: 'PVD7',
            pvd_15: 'PVD15',
            pvd_30: 'PVD30',
            pvd_60: 'PVD60',
            pvd_90: 'PVD90',
            mdv_7: 'MDV7',
            mdv_15: 'MDV15',
            mdv_30: 'MDV30',
            mdv_90: 'MDV90',
            stock_excess: 'Exced. L',
            coverage_period: 'TC Ci',
            stock_period: 'ESt. Ci.',
            coverage_safety: 'TC S',
            stock_safety: 'Est. S',
            stock_total: 'Est. Total',
            price: 'Preço',
            cost: 'Custo',
            actions: 'Ações'
        }
    }

    static get fieldTypes() {
        return {
            branch: 'text',
            pvd_7: 'float',
            pvd_15: 'float',
            pvd_30: 'float',
            pvd_60: 'float',
            pvd_90: 'float',
            mdv_7: 'float',
            mdv_15: 'float',
            mdv_30: 'float',
            mdv_90: 'float',
            stock_excess: 'int',
            coverage_period: 'int',
            stock_period: 'int',
            coverage_safety: 'int',
            stock_safety: 'int',
            stock_total: 'float',
            price: 'float',
            cost: 'float',
            actions: 'text'
        }
    }

    static get visibleFields() {
        return {
            branch: true,
            pvd_7: false,
            pvd_15: false,
            pvd_30: true,
            pvd_60: true,
            pvd_90: true,
            mdv_7: false,
            mdv_15: false,
            mdv_30: false,
            mdv_90: true,
            stock_excess: true,
            coverage_period: true,
            stock_period: true,
            coverage_safety: true,
            stock_safety: true,
            stock_total: true,
            price: true,
            cost: true,
            actions: false
        }
    }
    static get visibleFieldsDaily() {
        return {
            branch: true,
            pvd_7: true,
            pvd_15: true,
            pvd_30: true,
            pvd_60: false,
            pvd_90: false,
            mdv_7: true,
            mdv_15: true,
            mdv_30: true,
            mdv_90: false,
            stock_excess: true,
            coverage_period: true,
            stock_period: true,
            coverage_safety: true,
            stock_safety: true,
            stock_total: true,
            price: true,
            cost: true,
            actions: false
        }
    }

    static get editableFields() {
        return {
            simulation: true,
            dc_ids: true,
            mdv_90: true,
            stock_excess: true,
            coverage_period: true,
            stock_period: true,
            coverage_safety: true,
            stock_safety: true,
            stock_total: true,
            price: true,
            cost: true,
            actions: true
        }
    }
}

class NewDCParameter {
    constructor() {
        this.dc_channel = ''
        this.dc_cost = ''
        this.dc_price = ''
        this.dc_coverage_period = ''
        this.dc_coverage_safety = ''
        this.dc_upper_limit_stock_reserve = ''
        this.dc_lower_limit_stock_reserve = ''
    }

    static get fieldNames() {
        return {
            dc_channel: 'Canal',
            dc_cost: 'Custo',
            dc_price: 'Preço',
            dc_coverage_period: 'TC Ci',
            dc_coverage_safety: 'TC S',
            dc_upper_limit_stock_reserve: 'Lim Máx Est',
            dc_lower_limit_stock_reserve: 'Lim Min Est'
        }
    }

    static get fieldTypes() {
        return {
            dc_channel: 'select',
            dc_cost: 'text',
            dc_price: 'text',
            dc_coverage_period: 'text',
            dc_coverage_safety: 'text',
            dc_upper_limit_stock_reserve: 'text',
            dc_lower_limit_stock_reserve: 'text'
        }
    }

    static get visibleFields() {
        return {
            dc_channel: true,
            dc_cost: true,
            dc_price: true,
            dc_coverage_period: true,
            dc_coverage_safety: true,
            dc_upper_limit_stock_reserve: true,
            dc_lower_limit_stock_reserve: true
        }
    }

    static get editableFields() {
        return {
            dc_channel: true,
            dc_cost: true,
            dc_price: true,
            dc_coverage_period: true,
            dc_coverage_safety: true,
            dc_upper_limit_stock_reserve: true,
            dc_lower_limit_stock_reserve: true
        }
    }

    static get createFields() {
        return {
            dc_channel: true,
            dc_cost: true,
            dc_price: true,
            dc_coverage_period: true,
            dc_coverage_safety: true,
            dc_upper_limit_stock_reserve: true,
            dc_lower_limit_stock_reserve: true
        }
    }
}

export default DCParameter

export { DCParameter, NewDCParameter }
